module.exports = __webpack_public_path__ + "static/media/thumb3.3c9f6f60.png";